"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Heading = function Heading(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement("h6", {
    className: _style["default"].heading
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: text
  }));
};
var _default = exports["default"] = Heading;